import React from 'react';
import { AttendanceLoginDetail } from '../../types';
import { SimpleGrid, Skeleton } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
import { TextValueField } from '../common/TextValueField';
import {
    MdAccessTime,
    MdCalendarToday,
    MdCheckCircle,
    MdCloud,
    MdDirections,
    MdFace,
    MdLocationOn,
    MdNote,
    MdPerson,
} from 'react-icons/md';

export const AttendanceLoginInfoTable: React.FC<{ attendance?: AttendanceLoginDetail; isLoading: boolean }> = ({
    attendance,
    isLoading,
}) => {
    const intl = useIntl();

    if (isLoading || !attendance) {
        return <Skeleton height={250} />;
    }

    const positionMarkedAtValue = attendance.positionMeasuredAt
        ? `${intl.formatDate(new Date(attendance.positionMeasuredAt), {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
          })} ${intl.formatTime(attendance.positionMeasuredAt)}`
        : '-';

    return (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
            {attendance?.approver && (
                <TextValueField
                    smallVariant
                    label={intl.formatMessage({ id: 'field.approvedBy' })}
                    value={`${attendance.approver.firstName} ${attendance.approver.surname}`}
                    icon={<MdCheckCircle />}
                />
            )}
            {attendance?.creator && (
                <TextValueField
                    smallVariant
                    label={intl.formatMessage({ id: attendance.manual ? 'attendance.manual' : 'createdBy' })}
                    value={`${attendance.creator.firstName} ${attendance.creator.surname}`}
                    icon={<MdPerson />}
                />
            )}
            <TextValueField
                smallVariant
                label={intl.formatMessage({ id: 'attendance.positionMarkedAt' })}
                value={positionMarkedAtValue}
                icon={<MdLocationOn />}
            />
            <TextValueField
                smallVariant
                label={intl.formatMessage({ id: 'field.date' })}
                value={intl.formatDate(new Date(attendance.createdAt), {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                })}
                icon={<MdCalendarToday />}
            />
            <TextValueField
                smallVariant
                label={intl.formatMessage({ id: 'attendance.time' })}
                value={intl.formatTime(attendance.createdAt)}
                icon={<MdAccessTime />}
            />
            <TextValueField
                smallVariant
                label={intl.formatMessage({ id: 'type' })}
                value={intl.formatMessage({ id: attendance.direction })}
                icon={<MdDirections />}
            />
            <TextValueField
                smallVariant
                label={intl.formatMessage({ id: 'positionValidation' })}
                value={intl.formatMessage({ id: `POSITION_${attendance.positionValidation}` })}
                icon={<MdLocationOn />}
            />
            <TextValueField
                smallVariant
                label={intl.formatMessage({ id: 'faceRecognition' })}
                value={intl.formatMessage({ id: `FACE_${attendance.faceValidation}` })}
                icon={<MdFace />}
            />
            <TextValueField smallVariant label={intl.formatMessage({ id: 'note' })} value={attendance.note || '-'} icon={<MdNote />} />
            {attendance.isOfflineLogged && attendance.updatedAt && (
                <TextValueField
                    smallVariant
                    label={intl.formatMessage({ id: 'attendance.offline.uploadedAt' })}
                    value={`${intl.formatDate(attendance.updatedAt)} ${intl.formatTime(attendance.uploadedAt!)}`}
                    icon={<MdCloud />}
                />
            )}
        </SimpleGrid>
    );
};
